import * as React from 'react';
import * as moment from 'moment';
import { UIState } from 'data/UIState';
import { observer } from 'mobx-react';
import { observable, action, computed, toJS } from 'mobx';

import './GoalsSubPage.pcss';
import { JournalData } from 'data/JournalData';
import { Button } from 'components/widgets/Button';
import UserDataSource from "data/UserDataSource";
import {Alert} from "../../data/Alert";

@observer 
class GoalsSubPage extends React.Component {    
  render() {
    return UIState.isGoals ? <Goals /> : null;
  }
}

@observer
class Goals extends React.Component {
  @observable longTermGoal:any = null;
  @observable shortTermGoals:Array<any> = [];
  @observable accomplishedGoals:Array<any> = [];
  @observable hasChanges:boolean = false;
  @observable savingGoals:boolean = false;
  @observable failedToSaveGoals:boolean = false; // allows for save again...

  constructor(props){
    super(props);
    this.init();
  }

  init = () => {
      let longTermGoal:any = null;
      const shortTermGoals:Array<any> = [];
      const accomplishedGoals:Array<any> = [];

      if(UIState.user.goals && UIState.user.goals.length>0) {
        UIState.user.goals.forEach((g, idx)=>{
          const goal = JSON.parse(JSON.stringify(g));
          //goal._id = 'TMP_'+idx;
          if(goal.hasBeenAccomplished){
            accomplishedGoals.push(goal);
          } else if('short'===goal.type) {
            shortTermGoals.push(goal);
          } else if('long'===goal.type) {
            longTermGoal = goal;
          }
        });

        this.longTermGoal = longTermGoal;
        this.shortTermGoals = shortTermGoals;
        this.accomplishedGoals = accomplishedGoals;
        this.hasChanges = false;
        
      }
      this.savingGoals = false;
      this.failedToSaveGoals = false;
  }

handleAddLongTermGoal = () => {
  const id = 'TMP_'+(new Date()).getTime();
  this.longTermGoal = { description:'', type:'long', _id:id, dateAccomplished:null };
  this.hasChanges = true;
  setTimeout(()=>{
      const ele = document.getElementById('LongTermGoalInput')
      if(ele) { ele.focus(); }
    }, 100);
}

handleAddShortTermGoal = () => {
  const id = 'TMP_'+(new Date()).getTime();
  this.shortTermGoals.push( { description:'', type:'short', _id:id, dateAccomplished:null } );
  this.hasChanges = true;
  setTimeout(()=>{
    const ele = document.getElementById('ShortTermGoalInput'+(this.shortTermGoals.length-1))
    if(ele) { ele.focus(); }
  }, 100);
}

saveGoals = () => {    
  if(this.hasChanges) {
    this.savingGoals = true;
    let goals:Array<any> = [];

    if(this.longTermGoal) { goals.push(JSON.parse(JSON.stringify(this.longTermGoal))); }
    if(this.shortTermGoals.length>0) { goals = goals.concat(JSON.parse(JSON.stringify(this.shortTermGoals))); }
    if(this.accomplishedGoals.length>0) { goals = goals.concat(JSON.parse(JSON.stringify(this.accomplishedGoals))); }

    goals.forEach(goal=>{ delete goal._id; });

    UserDataSource.saveUserGoals(UIState.user, goals)
      .then(()=>{
        this.hasChanges = false;
        this.savingGoals = false;
        this.failedToSaveGoals = false;
      })
      .catch(()=>{
        alert('Failed to save! Your Internet connection may be unstable. Please try again.');
        this.savingGoals = false;
        this.failedToSaveGoals = true;
      });

  }
}

@action
handleMarkLTGoalAccomplished = (goal) => {
  this.savingGoals = true;
  JournalData.createGoalCompleteJournalEntry(goal.description, false)
  .then(()=>{
    goal.dateAccomplished = new Date();
    goal.hasBeenAccomplished = true;
    this.accomplishedGoals.push(goal);
    this.longTermGoal = null;
    this.hasChanges = true;
    this.saveGoals();
    UIState.setAriaLiveAnnouncement('Goal marked as completed and moved to Completed Goals.');
  })
  .catch(()=>{
    Alert.alert('Failed to mark goal complete. Please make sure that your Internet connection is stable and try again.');
    this.savingGoals = false;
  });
}

@action
handleUpdateLTGoalDescription = (goal, desc) => {
  this.longTermGoal.description = desc;
  this.hasChanges = true;
}

@action
handleDeleteLTGoal = (goal) => {
  this.longTermGoal = null;
  this.hasChanges = true;
  this.saveGoals();
}

@action
handleMarkGoalAccomplished = (goal) => {
  this.savingGoals = true;
  JournalData.createGoalCompleteJournalEntry(goal.description, true)
  .then(()=>{
    const goalIdx = this.shortTermGoals.findIndex(g=>g._id===goal._id);
    this.shortTermGoals[goalIdx].dateAccomplished = new Date();
    this.shortTermGoals[goalIdx].hasBeenAccomplished = true;
    this.accomplishedGoals.push(this.shortTermGoals[goalIdx]);
    this.shortTermGoals.splice(goalIdx, 1);
    this.hasChanges = true;
    this.saveGoals();
    UIState.setAriaLiveAnnouncement('Goal marked as completed and moved to Completed Goals.');
  })
  .catch(()=>{
    Alert.alert('Failed to mark goal complete. Please make sure that your Internet connection is stable and try again.');
    this.savingGoals = false;
  });

} 

@action
handleUpdateGoalDescription = (goal, v) => {
  const goalIdx = this.shortTermGoals.findIndex(g=>g._id===goal._id);
  this.shortTermGoals[goalIdx].description = v;
  this.hasChanges = true;
}

@action
handleDeleteGoal = (goal) => {
  const goalIdx = this.shortTermGoals.findIndex(g=>g._id===goal._id);
  this.shortTermGoals.splice(goalIdx, 1);
  this.hasChanges = true;
  this.saveGoals();
}

@action
handleDeteleAccomplishedGoal = (goal) => {
  const goalIdx = this.accomplishedGoals.findIndex(g=>g._id===goal._id);
  this.accomplishedGoals.splice(goalIdx, 1);
  this.hasChanges = true;
  this.saveGoals();
}

@computed
get disabled() {
  return this.savingGoals || this.failedToSaveGoals;
}

render() {
  return (
      <div className="goalsSubPage">

        <div className="top"  aria-hidden>
          <i className="material-icons" aria-hidden>check_box</i>
          <p aria-hidden>Goals</p>
        </div>
        

        <div className="block ltgoal">

            <h2>Long Term Goal</h2>
            <p>This is your core goal throughout the program (i.e. lose 5 pounds)</p>

            {this.longTermGoal ? 
              <div className="goals">
                <GoalInput
                  key={this.longTermGoal._id}
                  goal={this.longTermGoal} 
                  onMarkGoalAccomplished={this.handleMarkLTGoalAccomplished} 
                  onUpdateGoalDescription={this.handleUpdateLTGoalDescription} 
                  onDeleteGoal={this.handleDeleteLTGoal}
                  onSave={this.saveGoals}
                  disabled={this.disabled}
                  inputId={'LongTermGoalInput'}
                /> 
              </div>          
            :
              <Button
                className={'three-band-focus'}
                flat
                disabled={this.disabled}
                onClick={this.handleAddLongTermGoal}
              >Add Long Term Goal</Button>

            }

        </div>


        <div className="block">
          <h2>Short Term Goals</h2>
          <p>These are SMART goals (i.e. exercise 20 minutes, 4 times a week). It’s recommended to have 3 short term goals at time, but you can have as many (or few) as you want.</p>
          {this.shortTermGoals.length>0 &&
          <div className="goals" aria-roledescription="list">
            {this.shortTermGoals.map((shortTermGoal, idx)=>{
              return (
                <GoalInput 
                  key={shortTermGoal._id} 
                  goal={shortTermGoal} 
                  onMarkGoalAccomplished={this.handleMarkGoalAccomplished} 
                  onUpdateGoalDescription={this.handleUpdateGoalDescription} 
                  onDeleteGoal={this.handleDeleteGoal} 
                  onSave={this.saveGoals}
                  disabled={this.disabled}
                  inputId={'ShortTermGoalInput'+idx}
                /> 
              );            
            })}
          </div>
          }
          
          {this.shortTermGoals.length<3 ? 
            <Button
              className={'three-band-focus'}
              flat
              disabled={this.disabled} onClick={this.handleAddShortTermGoal}>Add Goal</Button>
            :
            <p><em>(Max 3 short term goals at a time)</em></p>
          }
          </div>

          {this.accomplishedGoals.length>0 && 
             <div className="block" style={{marginTop:'32px', marginBottom:'200px'}}>
              <h2>Completed Goals</h2>          
              <p>These are the goals that you have marked as accomplished! When you did that, a note was also added to your journal.</p>
              <div className="goals accomplished" aria-roledescription="list">
              {this.accomplishedGoals.map((accomplishedGoal)=>{
                return (
                  <GoalAccomplished  key={accomplishedGoal._id} goal={accomplishedGoal} onDeleteGoal={this.handleDeteleAccomplishedGoal} />              
                );
              })} 
              </div>
            </div>  
          }
        
        {this.failedToSaveGoals &&
        <div className="actionBar">        
          <button className="revert" disabled={this.savingGoals} type="button" onClick={()=>{ if(confirm('You will lose all changes made to your goals.')){ this.init(); } }}>REVERT</button>
          <div></div>
          <button className="save" disabled={this.savingGoals} type="button" onClick={this.saveGoals}>SAVE CHANGES</button>
        </div>
        }

      </div>
  );
}
}

const GoalAccomplished = (props:{goal:any, onDeleteGoal:(goal:any)=>void}) => {
const className = "goal accomplished "+props.goal.type;
const completed = moment(props.goal.dateAccomplished).format('llll');
return (
  <div className={className}>
    <p>
      <strong>{props.goal.description}</strong><br/>
      {completed}
    </p>
    <button className="trash three-band-focus" aria-label={`Remove ${props.goal.description} from completed goals.`}
            onClick={()=>{ if(confirm('Are you sure you want to remove this completed goal?')) { props.onDeleteGoal(props.goal); }}}><i className="material-icons">delete</i></button>
  </div>
);
}

interface GoalInputProps {
  goal:any,
  onSave:()=>void,
  onMarkGoalAccomplished:(goal:any)=>void,
  onDeleteGoal:(goal:any)=>void,
  onUpdateGoalDescription:(goal:any, desc:string)=>void,
  disabled:boolean,
  inputId?:string,
}

@observer
class GoalInput extends React.Component<GoalInputProps> {
  @observable checked:boolean = false;
  @observable currentGoalDescription = "";
  @observable previousGoalDescription = "";

  constructor(props:GoalInputProps) {
    super(props);
    this.currentGoalDescription = this.props.goal.description || "";
    this.previousGoalDescription = this.props.goal.description || "";
  }

  handleBlur = () => {
    // if no change, bail
    // if change, wait 500ms and save
    // if(this.currentGoalDescription!==this.previousGoalDescription) {
    //   setTimeout(()=>{
    //     if(this.currentGoalDescription!==this.previousGoalDescription) {
    //       this.handleSave();
    //     }
    //   }, 500);
    // }
  }


  handleSave = () => {
    this.previousGoalDescription = this.currentGoalDescription;
    this.props.onUpdateGoalDescription(this.props.goal, this.currentGoalDescription)
    this.props.onSave();
  }

  handleCancel = () => {
    this.currentGoalDescription = this.previousGoalDescription;
    this.handleSave();
  }


  handleMarkGoalAccomplished = () => {
    if(!this.checked) {
      this.checked = true;
      setTimeout(()=>{
        this.props.onMarkGoalAccomplished(this.props.goal);
      }, 500);
    }
  }

  @computed
  get markAccomplishedDisabled() {
    return this.disabled || this.props.goal.description && this.props.goal.description.trim().length===0;
  }

  @computed
  get disabled() {
    return this.props.disabled || this.checked;
  }

  render() {
    const checkboxClass = this.checked ? 'fa fa-check-square' : 'fa fa-square-o';
    return (
      <div className="goal">
        <div style={{display:'flex', alignItems:'center', flexGrow:1, position:"relative" , paddingRight:'16px', maxWidth:'365px'}}>
        <input
          placeholder={'describe your goal...'}
          id={this.props.inputId}
          onBlur={this.handleBlur}
          disabled={this.disabled}
          value={this.currentGoalDescription}
          onChange={(e)=>{
            this.currentGoalDescription = e.target.value;
          }}
          style={{paddingRight:'80px', marginRight:0}}
        />
          {this.currentGoalDescription !== this.previousGoalDescription &&
            <div style={{display:'flex', alignItems:'center', marginLeft:'16px', position:"absolute", top:0, right:'24px', height:'42px'}}>
                <button onClick={this.handleSave} disabled={this.disabled}><i className="material-icons" style={{height:'42px'}}>save</i></button>
                <button onClick={this.handleCancel} disabled={this.disabled} ><i className="material-icons" style={{height:'42px'}}>cancel</i></button>
            </div>
          }
        </div>
        {this.currentGoalDescription === this.previousGoalDescription && this.currentGoalDescription ?
          <button
            aria-label={`Complete ${this.props.goal.description}`}
            style={{marginRight:'8px'}}
            className="three-band-focus"
            disabled={this.markAccomplishedDisabled}
            onClick={this.handleMarkGoalAccomplished}><i className={checkboxClass}></i>&nbsp;&nbsp; Complete</button>
          :
            <div style={{flexGrow:1}}></div>
          }
          <button
            aria-label={`Remove goal ${this.props.goal.description}`}
            className=" three-band-focus'" disabled={this.disabled} onClick={()=>{ this.props.onDeleteGoal(this.props.goal); }}><i className="material-icons">delete</i></button>
      </div>
    );
  }
}




export { GoalsSubPage };
